
import { Component, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { DeviceType, AppModule } from "@/store/modules/app";
import { SettingsModule } from "@/store/modules/settings";
import { AppMain, Navbar, Settings, Sidebar, TagsView } from "./components";
import RightPanel from "@/components/right-panel/index.vue";
import ResizeMixin from "./mixin/resize";
import { UserModule } from "@/store/modules/user";

@Component({
    name: "Layout",
    components: {
        AppMain,
        Navbar,
        RightPanel,
        Settings,
        Sidebar,
        TagsView,
    },
})
export default class extends mixins(ResizeMixin) {
    get classObj() {
        return {
            hideSidebar: !this.sidebar.opened,
            openSidebar: this.sidebar.opened,
            withoutAnimation: this.sidebar.withoutAnimation,
            mobile: this.device === DeviceType.Mobile,
        };
    }

    get showSettings() {
        return SettingsModule.showSettings;
    }

    get showTagsView() {
        return SettingsModule.showTagsView;
    }

    get fixedHeader() {
        return SettingsModule.fixedHeader;
    }

    @Watch("$route")
    changeRoute(val: any) {
        this.$nextTick(() => {
            const el = (this as any).$refs["scrollBarRef"].wrap;

            if (el.scrollTop != 0) {
                el.scrollTop = 0;
            }
        });

        UserModule.SendAua({ sign: val.path, params: val.query });
    }

    mounted() {
        this.scrollTo();
    }

    beforeDestroy() {
        (this as any).$bus.$off("scrollBarTo");
    }

    private handleClickOutside() {
        AppModule.CloseSideBar(false);
    }

    scrollTo() {
        /*
         * 全局监听局部滚动条
         */
        (this as any).$bus.$on("scrollBarTo", (val: number) => {
            const el = (this as any).$refs["scrollBarRef"].wrap;

            if (val) {
                el.scrollTop = val;
            } else {
                const cubic = (value: any) => Math.pow(value, 3);
                const easeInOutCubic = (value: any) =>
                    value < 0.5
                        ? cubic(value * 2) / 2
                        : 1 - cubic((1 - value) * 2) / 2;
                const beginTime = Date.now();
                const beginValue = el.scrollTop;
                const rAF =
                    window.requestAnimationFrame ||
                    ((func) => setTimeout(func, 16));
                const frameFunc = () => {
                    const progress = (Date.now() - beginTime) / 500;
                    if (progress < 1) {
                        el.scrollTop =
                            beginValue * (1 - easeInOutCubic(progress));
                        rAF(frameFunc);
                    } else {
                        el.scrollTop = 0;
                    }
                };

                rAF(frameFunc);
            }
        });
    }
}
